import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'employee_guid': 'String!',
	'favourite_employee_guid': 'String!',
};

export default gql(`
	mutation delete_employee_to_employee_favourite( ${ HelperGraphql.createFields( fields ) } ) {
	    delete_employee_to_employee_favourite( ${ HelperGraphql.createVariables( fields ) } ) {
	        employee {
	        	guid
	        }
	    }
	}
`);

